
function initEssentiaChristmasGift() {
  const root = document.getElementById('essentia-christmas');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  'use strict';
  const tabs = Array.from(document.querySelectorAll('[role="tab"]'));
  const guides = Array.from(document.querySelectorAll('[data-guide]'));
  const hero = document.getElementById('hero-image');
    function chooseEdition(edition, focus = false) {
    if (!['him','her'].includes(edition)) return;
    tabs.forEach(tab => { const selected = tab.dataset.edition === edition; tab.setAttribute('aria-selected', String(selected)); tab.tabIndex = selected ? 0 : -1; if (focus && selected) tab.focus(); });
    guides.forEach(guide => { guide.hidden = guide.dataset.guide !== edition; });
    const photo = document.querySelector('[data-guide="' + edition + '"] .bottle-photo > img');
    hero.src = photo.currentSrc || photo.src;
    hero.alt = photo.alt;
  }
  tabs.forEach((tab, index) => {
    tab.addEventListener('click', () => chooseEdition(tab.dataset.edition));
    tab.addEventListener('keydown', event => {
      let next;
      if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
      if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
      if (event.key === 'Home') next = 0;
      if (event.key === 'End') next = tabs.length - 1;
      if (next === undefined) return;
      event.preventDefault();
      chooseEdition(tabs[next].dataset.edition, true);
    });
  });
  guides.forEach(guide => {
    const details = Array.from(guide.querySelectorAll('.scent-list details'));
    const selectors = Array.from(guide.querySelectorAll('.bottle-selector'));
    function highlight(index) { selectors.forEach((button, i) => button.setAttribute('aria-pressed', String(i === index))); }
    selectors.forEach((button, index) => button.addEventListener('click', () => { details.forEach((detail, i) => { detail.open = i === index; }); highlight(index); }));
    details.forEach((detail, index) => detail.addEventListener('toggle', () => { if (detail.open) { details.forEach((other, i) => { if (i !== index) other.open = false; }); highlight(index); } else if (!details.some(item => item.open)) { selectors.forEach(button => button.setAttribute('aria-pressed', 'false')); } }));
  });
  const edition = new URLSearchParams(location.search).get('set');
  if (edition === 'her' || edition === 'him') chooseEdition(edition);
}
initEssentiaChristmasGift();
document.addEventListener('shopify:section:load', initEssentiaChristmasGift);
